import React from "react"
import { Routes, Route } from "react-router-dom";

import NftHomeComponents from "../pages/Nft";
import NotFound from "../pages/NotFound";
import PayNft from "../pages/PayNftComponent";
import Pool from "../pages/games/Pool";
import Checkers from "../pages/games/Checkers";
import EsproPay from "../pages/esproPay";
import Home from '../pages/Home'
import Tournament from '../pages/Tournament'
import TournamentList from '../pages/TournamentList'
import UserAccount from '../pages/UserAccount'
import H2HLobby from '../pages/H2HLobby'
import TournamentLobby from '../pages/TournamentLobby'
import DisputePage from '../pages/DisputePage'
import Notifications from '../pages/Notifications'

const AllRoutes = () => {
  return (
      <div>

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/checkers" element={<Checkers />} />
            <Route path="/pool" element={<Pool />} />
            <Route path="/tournaments" element={<TournamentList />} />
            <Route path="/tournament" element={<Tournament />} />
            <Route path="/account" element={<UserAccount />} />
            <Route path="/nftpaid" element={<PayNft />}/>
            <Route path="/espropay" element={<EsproPay />}/>
            <Route path="/challenge/:cid" element={<H2HLobby />} />
            <Route path="/tournament/:tid" element={<TournamentLobby />} />
            <Route path="/dispute/:did" element={<DisputePage />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="*" element={<NotFound />}/>

          </Routes>

      </div>
  )
}
export default AllRoutes

// const userRoutes = [
 
//   // this route should be at the end of all other routes
//   { path: "/", exact: true, component: () => <Navigate to="/dashboard" /> },
// ]

// const authRoutes = [
//     { path: "/nft", component: NftHomeComponents },
//     { path: "/", exact: true, component: () => <Navigate to="/nft" /> }
// ]

// export { userRoutes, authRoutes }